// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: Granite for Shopify (connect page, Settings → Integrations). Merged into the catalog by messages.en.ts. */
export const shopify = {
  "shopify.connect.title": "Connect a Shopify store",
  "shopify.connect.loading": "Loading the store…",
  "shopify.connect.cannot": "Can't connect this store",
  "shopify.connect.noCode": "This link is missing its code. Start again from the Granite app in Shopify.",
  "shopify.connect.store": "Store",
  "shopify.connect.owner": "Connect it to",
  "shopify.connect.personal": "Your account",
  "shopify.connect.workspace": "Workspace",
  "shopify.connect.plan": "{plan} plan",
  "shopify.connect.noOwners": "There is no account you can connect this store to.",
  "shopify.connect.explain": "The store's catalog will be imported into a new vault, \"{vault}\", owned by the account you choose.",
  "shopify.connect.plans": "Every feature of the app works on every Granite plan. The store's notes count toward the account's storage.",
  "shopify.connect.movingWarning": "This store is connected to {account} now. Connecting it here moves it; the old vault stays where it is.",
  "shopify.connect.connect": "Connect",
  "shopify.connect.cancel": "Cancel",
  "shopify.connect.doneTitle": "Store connected",
  "shopify.connect.done": "Connected. You can close this tab and go back to Shopify.",
  "shopify.connect.openVault": "Open the vault",
  "shopify.vaultName": "{store} (Shopify)",
  "shopify.settings.title": "Shopify stores",
  "shopify.settings.description": "Stores connected with the Granite for Shopify app. Each store's catalog is in its own vault.",
  "shopify.settings.list": "Shopify stores",
  "shopify.settings.none": "No Shopify stores are connected.",
  "shopify.settings.getApp": "Get Granite for Shopify",
  "shopify.settings.openVault": "Open vault",
  "shopify.settings.disconnect": "Disconnect",
  "shopify.settings.disconnectConfirm": "Disconnect {store}? It stops syncing. Its vault and notes stay where they are.",
  "shopify.settings.workspaceOwned": "Workspace",
  "shopify.settings.connectedOn": "Connected {date}",
  "shopify.status.connected": "Connected",
  "shopify.status.notConnected": "Not connected",
  "shopify.status.uninstalled": "App uninstalled",
  "shopify.status.redacted": "Removed",
  "error.shopify_link_invalid": "This link has expired or was already used. Start again from the Granite app in Shopify.",
  "error.shopify_owner_not_allowed": "You can't connect a store to that account. Choose your own account or a workspace you administer.",
};
